import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {FormatCellPipe} from './format-cell.pipe';
import {StyleCellDirective} from './style-cell.directive';
import {StyleRowDirective} from './style-row.directive';
import {TableLayoutComponent} from './table-layout.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [TableLayoutComponent, StyleRowDirective, StyleCellDirective, FormatCellPipe],
  exports: [TableLayoutComponent, StyleRowDirective, StyleCellDirective, FormatCellPipe],
})
export class DynamicGridModule {}
